import { render, staticRenderFns } from "./site-setting.vue?vue&type=template&id=0cd6a9fc&scoped=true"
import script from "./site-setting.vue?vue&type=script&lang=js"
export * from "./site-setting.vue?vue&type=script&lang=js"
import style0 from "./site-setting.vue?vue&type=style&index=0&id=0cd6a9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6a9fc",
  null
  
)

export default component.exports